import { RotateCw } from "lucide-react";
import type { ComponentProps } from "react";

import { Tk, useTranslation2 } from "../i18n";

import { Button } from "./button";
import { cn } from "./utils";

type Props = ComponentProps<"div"> & {
  message?: string | undefined;
  onTryAgain?: (() => void) | undefined;
};

function QueryError({ message, onTryAgain, className, ...props }: Props) {
  const {
    postproc: { tc },
  } = useTranslation2();

  return (
    <div className={cn("flex flex-col items-center gap-2", className)} {...props}>
      <p className="text-center text-2xl">{message ?? tc(Tk.THERE_WAS_AN_ERROR_LOADING_DATA)}</p>
      <Button variant="outline" onClick={onTryAgain}>
        {tc(Tk.TRY_AGAIN)}
        <RotateCw />
      </Button>
    </div>
  );
}

export { QueryError };
